module.exports = __webpack_public_path__ + "static/media/search.75c7e8ee.svg";